import { useEffect } from 'react';

type SelectionOverlayProps = {
  map: google.maps.Map | null;
  isLoaded: boolean;
  clickedPoint: { lat: number; lng: number } | null;
};

/**
 * 클릭한 포인트 1개에 반투명 원형 오버레이 + 펄스 애니메이션 표시
 */
export function SelectionOverlay({ map, isLoaded, clickedPoint }: SelectionOverlayProps) {
  useEffect(() => {
    if (!isLoaded || !map || !clickedPoint) return;

    const center = clickedPoint;

    // 내부 원 — 반투명 파란 영역
    const innerCircle = new google.maps.Circle({
      map,
      center,
      radius: 30,
      fillColor: '#055CB4',
      fillOpacity: 0.15,
      strokeColor: '#055CB4',
      strokeOpacity: 0.6,
      strokeWeight: 2,
      clickable: false
    });

    // 외부 원 — 펄스 애니메이션용
    const outerCircle = new google.maps.Circle({
      map,
      center,
      radius: 30,
      fillColor: '#055CB4',
      fillOpacity: 0.08,
      strokeColor: '#055CB4',
      strokeOpacity: 0.4,
      strokeWeight: 1,
      clickable: false
    });

    // 펄스 애니메이션: 외부 원이 확장 → 사라짐 반복
    let animFrame: number;
    let start: number | null = null;
    const DURATION = 1500;

    const animate = (timestamp: number) => {
      if (!start) start = timestamp;
      const elapsed = (timestamp - start) % DURATION;
      const progress = elapsed / DURATION;

      const radius = 30 + progress * 40;
      const opacity = 0.4 * (1 - progress);

      outerCircle.setRadius(radius);
      outerCircle.setOptions({
        strokeOpacity: opacity,
        fillOpacity: opacity * 0.2
      });

      animFrame = requestAnimationFrame(animate);
    };

    animFrame = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animFrame);
      innerCircle.setMap(null);
      outerCircle.setMap(null);
    };
  }, [map, isLoaded, clickedPoint]);

  return null;
}
